import { render } from "./Printing.vue?vue&type=template&id=0aab59a8&scoped=true"
const script = {}

import "./Printing.vue?vue&type=style&index=0&id=0aab59a8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aab59a8"]])

export default __exports__